import { axiosInstance } from "../../Utils/AxiosInstance";

// Same shape as the other Api files: always resolves to the axios response (or the error's response).
const call = async (request) => {
  try {
    const response = await request();
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

// Clients
export const getClientsApi = () => call(() => axiosInstance.get("ClientWorkClients/GetAll"));
export const getClientApi = (id) => call(() => axiosInstance.get(`ClientWorkClients/Get/${id}`));
export const saveClientApi = (payload) =>
  call(() =>
    payload.Id
      ? axiosInstance.put(`ClientWorkClients/Update/${payload.Id}`, payload)
      : axiosInstance.post("ClientWorkClients/Add", payload),
  );
export const deleteClientApi = (id) =>
  call(() => axiosInstance.delete(`ClientWorkClients/Delete/${id}`));

// Contracts
export const getContractsApi = () => call(() => axiosInstance.get("ClientWorkContracts/GetAll"));
export const getContractApi = (id) =>
  call(() => axiosInstance.get(`ClientWorkContracts/Get/${id}`));
export const saveContractApi = (payload) =>
  call(() =>
    payload.Id
      ? axiosInstance.put(`ClientWorkContracts/Update/${payload.Id}`, payload)
      : axiosInstance.post("ClientWorkContracts/Add", payload),
  );
export const deleteContractApi = (id) =>
  call(() => axiosInstance.delete(`ClientWorkContracts/Delete/${id}`));

// Running bills
export const getInvoicesApi = () => call(() => axiosInstance.get("ClientWorkInvoices/GetAll"));
export const getInvoiceApi = (id) => call(() => axiosInstance.get(`ClientWorkInvoices/Get/${id}`));
export const getInvoiceDefaultsApi = (contractId) =>
  call(() => axiosInstance.get(`ClientWorkInvoices/Defaults/${contractId}`));
export const saveInvoiceApi = (payload) =>
  call(() =>
    payload.Id
      ? axiosInstance.put(`ClientWorkInvoices/Update/${payload.Id}`, payload)
      : axiosInstance.post("ClientWorkInvoices/Add", payload),
  );
export const authorizeInvoiceApi = (id) =>
  call(() => axiosInstance.put(`ClientWorkInvoices/Authorize/${id}`));
export const cancelInvoiceApi = (id, reason) =>
  call(() =>
    axiosInstance.put(`ClientWorkInvoices/Cancel/${id}?reason=${encodeURIComponent(reason)}`),
  );
export const deleteInvoiceApi = (id) =>
  call(() => axiosInstance.delete(`ClientWorkInvoices/Delete/${id}`));

// Reports (optional billing-date range)
const reportParams = (from, to) => ({ params: { from: from || undefined, to: to || undefined } });
export const getContractBillingAbstractApi = (from, to) =>
  call(() =>
    axiosInstance.get("ClientWorkReports/ContractBillingAbstract", reportParams(from, to)),
  );
export const getRetentionLedgerApi = (from, to) =>
  call(() => axiosInstance.get("ClientWorkReports/RetentionLedger", reportParams(from, to)));
export const getMobilizationAdvanceApi = (from, to) =>
  call(() => axiosInstance.get("ClientWorkReports/MobilizationAdvance", reportParams(from, to)));
export const getArAgingApi = (from, to) =>
  call(() => axiosInstance.get("ClientWorkReports/ArAging", reportParams(from, to)));

// Dashboard (optional contract and billing-date range)
export const getClientWorkDashboardApi = (contractId, from, to) =>
  call(() =>
    axiosInstance.get("ClientWorkReports/Dashboard", {
      params: { contractId: contractId || undefined, from: from || undefined, to: to || undefined },
    }),
  );
